import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import Container from "react-bootstrap/Container"
import ButtonToolbar from "react-bootstrap/ButtonToolbar"
import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"

import Layout from "./layout"
import SEO from "./seo"
import {ApplicationPageTitle} from "./page-title"
import InfoModal from "./modals"
import {appsAreOpen, appStatusText} from "./dates"

const ApplicationAlert = props => {
  let appAlert = null
  if (props.submitted) {
    appAlert = (
      <div className="alert alert-warning">
        <i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;
        <strong>This application has already been submitted!</strong> You
        can continue to view it on this page. If you'd like to
        make a change to this application before the deadline,
        email <a href="mailto:cnda@lisc.org">cnda@lisc.org</a>.
      </div>
    )
  } else if (!appsAreOpen) {
    appAlert = (
      <div className="alert alert-warning">
        <i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;
        <strong>Applications are currently closed.</strong> You may not submit
        an application until the application period opens. {appStatusText}
      </div>
    )
  }
  return appAlert
}

const OptionalMediaText = props => {
  return (
    <div className="col-sm-10 offset-sm-1 mb-3">
      <small className="form-text text-muted">
        Due to the importance of health and safety for CNDA applicants and volunteers during the COVID-19 pandemic, the in-person site visits that are traditionally part of the CNDA site visit process will be virtual meetings with applicants and volunteer judges to take place on Jan. 18 and Jan. 19. Given that change, each CNDA applicant this year has the option to submit a short video (2-4 minutes) or photographs or other visual images (8-10) along with an application. Videos and visual images should showcase the project or program and enhance the CNDA application. For example, video or visual images could provide a tour of a building/project, feature a series of brief interviews, or any creative way that  features your work in action in the community. Video/visual images do not need to be professionally shot or edited. Please review the criteria for the CNDA category you are applying under to determine the content to feature in the video or images submitted.
      </small>
    </div>
  )
}

const ApplicationFormContainer = props => (
  <Layout>
    <SEO title={props.data.title} />
    <Container>
      <InfoModal
        status={props.state.status}
        uuid={props.state.uuid}
        permalink={props.state.permalink}
        submitStep={props.state.submitStep}
        closeModal={props.closeModal}
      />
      <ApplicationPageTitle
        titleText={props.data.titleText}
      />
      <div className="col-sm-10 offset-sm-1 mb-3">
        <p>
          {props.data.awardDescription}&nbsp;
          <a
            href={props.data.awardLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more about the award &raquo;
          </a>
        </p>
      </div>
      <Img
        fluid={props.data.banner.childImageSharp.fluid}
        className="mb-3"
      />
      <div className="text-center">
        <p className="small">
          <em>
            <a
              href={props.data.headerImageLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {props.data.headerImageProject}
            </a>
            {props.data.headerImageDescription}
          </em>
        </p>
      </div>
      
      <ApplicationAlert submitted={props.state.submitted} />
      <form onSubmit={props.handleSubmit} className="mb-5">

        {props.children}

        <ButtonToolbar className="float-right">
          <Button
            size="md"
            variant="secondary"
            className="mx-1"
            title={appsAreOpen ? "Save a draft of your application." : appStatusText}
            disabled={props.state.saving || props.state.submitting || props.state.submitted || !appsAreOpen}
            onClick={props.handleSave}>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="mr-1 mb-1"
              style={{display: (props.state.saving) ? 'inline-block' : 'none'}}
            />
            {props.state.saving ? <span>Saving...</span> : <span>Save as draft</span>}
          </Button>
          <Button
            size="md"
            variant="primary"
            type="submit"
            className="pull-right"
            title={appsAreOpen ? "Submit your application." : appStatusText}
            disabled={props.state.saving || props.state.submitting || props.state.submitted || !appsAreOpen}
          >
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="mr-1 mb-1"
              style={{display: (props.state.submitting) ? 'inline-block' : 'none'}}
            />
            {props.state.submitting ? <span>Submitting...</span> : <span>Submit</span>}
          </Button>
        </ButtonToolbar>
        <br />
      </form>
    </Container>
  </Layout>
)

export default ApplicationFormContainer
